var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.externalClick),expression:"externalClick"}],staticClass:"text-area-main",on:{"click":_vm.onClick}},[_c('label',{ref:"label",class:{
      'label-focus': _vm.labelFocusFlag,
      'textarea-label': !_vm.labelFocusFlag,
    }},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.error)?_c('span',{staticClass:"error-text padding-left-16"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('textarea',{ref:"textarea",class:[
        _vm.icon
          ? _vm.border
            ? ' form-control default-settings has-error padding'
            : ' form-control default-settings has-error padding'
          : _vm.border
          ? ' form-control default-settings has-error'
          : ' form-control default-settings has-error',
      ],style:([
        _vm.width ? 'width:' + _vm.width : '',
        _vm.error ? _vm.borderColorRed : '',
        _vm.disabled ? _vm.borderColorDisabled : '',
      ]),attrs:{"id":_vm.id,"type":"textarea","cols":_vm.columns,"rows":_vm.rows,"name":_vm.label,"readonly":_vm.readonly,"required":_vm.required,"disabled":_vm.disable,"maxlength":_vm.maxlength},domProps:{"value":_vm.modelValue},on:{"input":function($event){return _vm.updateValue($event.target.value)},"focus":_vm.focus,"blur":_vm.blur}}),(_vm.labelFocusFlag && _vm.count)?_c('div',{ref:"hint",staticClass:"hint-text",attrs:{"id":_vm.countId}},[_vm._v(" "+_vm._s(_vm.getCount())+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }